import { useContext, useEffect, useState } from 'react'
import axios from 'axios'
import { Link } from 'react-router'
import { Button, Layout, AlertContext } from '../widgets'
import * as routes from '../routes'
import {
  useTitle,
  Loading,
  withRouter,
} from '../shared'
import { PresetCell } from '../components'

const ProducerPresets = (props) => {
  const [state, replaceState] = useState({
    loading: true,
    presets: [],
    current_offset: 0,
    next_offset: 0,
    done: true
  })

  const setState = (subState) => {
    replaceState(state => {
      return {...state, ...subState}
    })
  }

  const { showAlertConfirm, showToast, handleError } = useContext(AlertContext)

  useEffect(() => {
    load([], state.current_offset)
  }, [])

  useTitle('Presets')

  const load = (existingPresets, offset) => {
    axios.get(routes.presetsPrivateUserUrl, {
      params: {
        offset: offset,
      }
    }).then((response) => {
      setState({
        presets: existingPresets.concat(response.data.data),
        current_offset: offset,
        next_offset: response.data.next_offset,
        done: response.data.done
      })
    }).catch((error) => {
      handleError(error)
    }).finally(() => {
      setState({ loading: false })
    })
  }

  const onShare = (preset) => {
    navigator.clipboard.writeText(preset.share_url).then(() => {
      showToast('Link copied to clipboard.')
    }, (err) => {
      showToast('Could not copy the preset to your clipboard!')
    })
  }

  const onDownload = (preset) => {
    axios.get(
      routes.dynamic(routes.presetDownloadUrl, preset.id),
      { responseType: 'blob' }
    ).then((response) => {
      const url = URL.createObjectURL(response.data)
      const link = document.createElement('a')
      link.href = url
      link.download = `${preset.name}.json`
      link.click()
      setTimeout(() => URL.revokeObjectURL(url))
    }).catch(
      handleError
    )
  }

  const onDelete = (preset) => {
    showAlertConfirm({
      title: 'Confirm Deletion',
      message: 'Are you sure you want to delete this preset? It will no longer be available to others.',
      callback: () => {
        setState({ loading: true })
        axios.delete(
          routes.dynamic(routes.presetUrl, preset.id)
        ).then((response) => {
          load([], 0)
        }).catch(
          handleError
        ).finally(() => {
          setState({ loading: false })
        })
      }
    })
  }

  if (state.loading) { return <Loading /> }

  const table =
    state.presets.length <= 0 ?
      <div className='user-content-none'>
        You don&apos;t have any presets yet - upload one or create some in the app!
      </div>
      :
      <div>
        <div className='layout-content'>
          {state.presets.map((preset) => <PresetCell preset={preset} key={preset.id} onShare={onShare} onDownload={onDownload} onDelete={onDelete} />)}
        </div>
        {!state.done &&
          <a href='#'
            onClick={e => {
              e.preventDefault()
              load(state.presets, state.next_offset)
            }}
          >
            See More
          </a>
        }
      </div>

  const content =
    <Layout>
      <Layout.Header className='presets-header'>
        Presets
        <Link to={routes.producerPresetsUploadPath}>
          <Button className='medium'>Upload Preset</Button>
        </Link>
      </Layout.Header>
      {table}
    </Layout>

  return (
    <div className='body-container'>
      {content}
    </div>
  )
}

export default withRouter(ProducerPresets)
